import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { STORE_VOCABULARY, STORE_VOCABULARY_MSB } from '@/graphql/Mystage/vocabulary';
import { bizmatesApi } from '@/utils/bizmatesApi';
import qs from 'qs';

import logger from '@/modules/Logger';

export const StoreVocabularyService = {
  // Method to fetch PDF from new GraphQL endpoint
    msb: async (word, lessonId, programId) => {
    logger.debug(`[Store Vocabulary] Store Vocabulary from MSB GraphQL endpoint`, {
      operation: 'vocabulary:store_vocabulary'
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.mutate({
      mutation: STORE_VOCABULARY_MSB,
      fetchPolicy: 'no-cache',
      variables: {
        word,
        lesson_id: lessonId,
        program_id: programId
      }
    });

    if (data?.storeVocabulary) {
      return data.storeVocabulary;
    } else {
      logger.error(`[Store Vocabulary] Empty result from store GraphQL API`, {
        operation: 'vocabulary:store_vocabulary',
        event_type: 4,
        word,
        lesson_id: lessonId,
        program_id: programId
      });
    }
  },

  mbti: async (word, lessonId, programId) => {
    logger.debug(`[Store Vocabulary] Store Vocabulary from MBTI GraphQL endpoint`, {
      operation: 'vocabulary:store_vocabulary'
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.mutate({
      mutation: STORE_VOCABULARY,
      fetchPolicy: 'no-cache',
      variables: {
        word,
        lesson_id: lessonId,
        program_id: programId
      }
    });

    if (data?.store_vocabulary) {
      return data.store_vocabulary;
    } else {
      logger.error(`[Store Vocabulary] Empty result from store GraphQL API`, {
        operation: 'vocabulary:store_vocabulary',
        event_type: 4,
        word,
        lesson_id: lessonId,
        program_id: programId
      });
    }
  },

  // Method to save vocabulary from legacy REST API endpoint
  legacy: async (word, lessonId, programId) => {
    logger.debug(`[Store Vocabulary] Saving using legacy REST API`, {
      operation: 'vocabulary:store_legacy'
    });

    const params = {
      word,
      lesson_id: lessonId,
      program_id: programId
    };

    try {
      const response = await new Promise((resolve, reject) => {
        bizmatesApi.post(
          'vocabulary/store',
          qs.stringify(params),
          {},
          res => resolve(res),
          err => reject(err)
        );
      });

      return response.data;
    } catch (error) {
      logger.error(`[Store Vocabulary] Error saving vocabulary`, {
        error,
        word,
        lesson_id: lessonId,
        program_id: programId
      });
      throw error;
    }
  }
};
